"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _productAreas = require("@insided/shared/utils/productAreas");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ProductAreaSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductAreaSelector, _Component);

  var _super = _createSuper(ProductAreaSelector);

  function ProductAreaSelector() {
    var _this$props$closeOnDr;

    var _this;

    (0, _classCallCheck2.default)(this, ProductAreaSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchValue: '',
      expandedProductAreas: _this.props.productAreas,
      closeOnDropdownClick: (_this$props$closeOnDr = _this.props.closeOnDropdownClick) !== null && _this$props$closeOnDr !== void 0 ? _this$props$closeOnDr : true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleCollapse", function (productId) {
      _this.setState(function (_ref) {
        var expandedProductAreas = _ref.expandedProductAreas;
        return {
          expandedProductAreas: (0, _productAreas.toggleCollapsePA)(expandedProductAreas, productId),
          closeOnDropdownClick: false
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ProductAreaSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          trigger = _this$props.trigger,
          triggerClass = _this$props.triggerClass,
          onMultiSelect = _this$props.onMultiSelect,
          onSelectItem = _this$props.onSelectItem,
          selectedProductAreas = _this$props.selectedProductAreas,
          isSearchable = _this$props.isSearchable,
          showBothCheckboxAndCollapse = _this$props.showBothCheckboxAndCollapse,
          labelId = _this$props.labelId,
          searchInputRef = _this$props.searchInputRef;
      var _this$state = this.state,
          closeOnDropdownClick = _this$state.closeOnDropdownClick,
          searchValue = _this$state.searchValue,
          expandedProductAreas = _this$state.expandedProductAreas;
      var filteredPA = (0, _productAreas.getFilteredProductAreas)(searchValue, expandedProductAreas);
      return (0, _preact.h)("div", {
        className: "product-area-selector-container"
      }, (0, _preact.h)(_dropdown.default, {
        closeOnDropdownClick: closeOnDropdownClick,
        popupName: "category-selector",
        className: "dropdown-selector category-selector",
        triggerElement: "div",
        trigger: trigger,
        triggerClass: triggerClass
      }, (0, _preact.h)("div", {
        className: "product-area-dropdown-options-container"
      }, isSearchable && (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        searchInputRef: searchInputRef,
        placeholder: "Search",
        value: searchValue,
        onSubmit: function onSubmit() {},
        onInput: function onInput(e) {
          return _this2.setState({
            searchValue: e.target.value
          });
        },
        onClear: function onClear() {
          return _this2.setState({
            searchValue: ''
          });
        }
      }), (0, _preact.h)(_NestedDropdown.default, {
        labelId: labelId,
        showBothCheckboxAndCollapse: showBothCheckboxAndCollapse,
        items: filteredPA,
        selectedItems: selectedProductAreas,
        onSelectItem: onSelectItem,
        onMultiSelect: onMultiSelect,
        onToggleCollapse: this.toggleCollapse,
        depth: 1
      }))));
    }
  }]);
  return ProductAreaSelector;
}(_preact.Component);

var _default = ProductAreaSelector;
exports.default = _default;